import type {ReactNode} from 'react'
import type {Client} from '@bugsnag/js'
import type {ErrorContext} from '@freckle/educator-entities/ts/common/helpers/exception-handlers/bugsnag-helper'
import BugsnagHelper from '@freckle/educator-entities/ts/common/helpers/exception-handlers/bugsnag-helper'
import {getEnvironment} from '@freckle/educator-entities/ts/config/environment'

function initBugsnag(): Client {
  const environment = getEnvironment(window.location.hostname)

  if (environment === 'localhost') {
    return {
      notify: () => {},
      start: () => {},
      getPlugin: () => ({
        createErrorBoundary: () => {
          return function MockErrorBoundary(props: {children: ReactNode}) {
            return props.children
          }
        }
      })
    } as unknown as Client
  }

  return BugsnagHelper.init((): ErrorContext => ({user: undefined}))!
}

const bugsnagClient: Client = initBugsnag()

export function logError(err: Error) {
  BugsnagHelper.logError(err)
}

export function logErrorAsUnhandled(err: Error) {
  BugsnagHelper.logErrorAsUnhandled(err)
}

export default bugsnagClient
